module.exports = __webpack_public_path__ + "static/media/banner-2-my.6a00e7db.jpg";